// extracted by mini-css-extract-plugin
export var carouselContainer = "LogoCarousel-module--carouselContainer--Vo4+q";
export var carouselTrack = "LogoCarousel-module--carouselTrack--goA2-";
export var logoCarouselWrapper = "LogoCarousel-module--logoCarouselWrapper--ohbOY";
export var logoImage = "LogoCarousel-module--logoImage--0Gi5X";
export var logoItem = "LogoCarousel-module--logoItem--txIMp";
export var scroll = "LogoCarousel-module--scroll--yDkEW";
export var title = "LogoCarousel-module--title--QupEF";